<template>
  <div id="order-form">
    <template
      v-if="
        [
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'spinOff',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(typeOrderModal) > -1
      "
    >
      <v-row>
        <v-col cols="12" md="12" class="mb-0 pb-0">
          <BrokerAlert
            :text="
              brokerMultiCurrency
                ? $t('views.orders.orderModal.needBrokerMulticurrency')
                : $t('views.orders.orderModal.needBroker')
            "
            marginClass="mt-3 mb-6"
            :brokerSearchLoading="brokerSearchLoading"
            :brokerSearchBrokers="brokerSearchBrokers"
          />
          <BrokerSearch
            v-model="myOrder.broker"
            :multiCurrency="brokerMultiCurrency"
            :brokers.sync="brokerSearchBrokers"
            :isLoading.sync="brokerSearchLoading"
            :disabled="loading || editing"
          />
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="12" md="12" class="mb-2 pb-0">
        <DatePicker
          v-model="myOrder.date"
          :label="$t('common.date')"
          :labelTime="$t('common.time')"
          :loading="loading"
          datePickerClass="mt-0 mb-0"
        />
      </v-col>
      <v-col
        v-if="['scrip', 'capitalIncrease'].indexOf(typeOrderModal) > -1"
        cols="12"
        md="12"
        class="mb-0 pb-0"
      >
        <div class="items-flex align-end">
          <v-text-field
            v-model="myOrder.positionQuantity"
            type="number"
            :label="$t(`views.orders.orderModal.scrip.positionQuantity.label`)"
            :disabled="loading"
            hide-details
          />
          <span class="ml-2">
            <InfoIcon
              :size="17"
              :text="$t(`views.orders.orderModal.scrip.positionQuantity.info`)"
            />
          </span>
        </div>
        <v-chip
          v-if="positionBrokerPositionNumber > 0"
          small
          class="mt-2"
          @click="getAllPositionNumberAndAssign('positionQuantity')"
        >
          <v-icon size="15" class="mr-1">mdi-basket-check</v-icon>
          {{ $t(`views.orders.orderModal.scrip.positionQuantity.getAllPositionNumber`) }}
        </v-chip>
      </v-col>
      <template
        v-if="
          [
            'buy',
            'bonus',
            'stakeReward',
            'drip',
            'sell',
            'switch',
            'spinOff',
            'sharePremium',
            'scrip',
            'capitalIncrease',
            'optionBuy',
            'optionSell',
            'commission',
            'paidInterest',
            'interest',
            'interestRetention',
            'deposit',
            'withdrawal',
            'brokerTransfer',
          ].indexOf(typeOrderModal) > -1
        "
      >
        <v-col
          v-if="
            ['buy', 'bonus', 'stakeReward', 'drip', 'sell'].indexOf(typeOrderModal) > -1 &&
            typeOrDerivativeType === 'commodity' &&
            ['GC', 'SI', 'PL', 'PA'].indexOf(position.ticker) > -1
          "
          cols="12"
          md="12"
          class="mb-0 mt-3 pb-0"
        >
          <v-btn-toggle v-model="myOrder.commodityUnit" mandatory class="commodity-unit-buttons">
            <v-btn
              small
              color="softBackgroundGrey"
              :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
              value="oz"
              @click="changeCommodityUnit('oz')"
            >
              {{ $t(`views.orders.orderModal.commodityUnit.oz`) }}
            </v-btn>
            <v-btn
              small
              color="softBackgroundGrey"
              :class="{ 'black--text': !$vuetify.theme.dark, 'white--text': $vuetify.theme.dark }"
              value="gr"
              @click="changeCommodityUnit('gr')"
            >
              {{ $t(`views.orders.orderModal.commodityUnit.gr`) }}
            </v-btn>
          </v-btn-toggle>
        </v-col>

        <v-col cols="12" md="4" :class="{ 'pt-0 mt-2': isSmAndDown }">
          <div class="items-flex align-end">
            <CurrencyInput
              v-if="['cash', 'crypto', 'commodity'].indexOf(typeOrDerivativeType) > -1"
              v-model="myOrder.positionNumber"
              :currency="getPositionNumberCurrency()"
              :label="$t(`views.orders.orderModal.positionNumber.${typeOrDerivativeType}`)"
              :disabled="loading"
              :class="{ 'pt-0 mt-0': isSmAndDown }"
            />
            <v-text-field
              v-else
              v-model="myOrder.positionNumber"
              type="number"
              :label="$t(`views.orders.orderModal.positionNumber.${typeOrDerivativeType}`)"
              :disabled="loading"
              hide-details
              :class="{ 'pt-0 mt-0': isSmAndDown }"
            />

            <div
              v-if="
                [
                  'interest',
                  'scrip',
                  'capitalIncrease',
                  'optionBuy',
                  'optionSell',
                  'spinOff',
                  'brokerTransfer',
                ].indexOf(typeOrderModal) > -1
              "
            >
              <span class="ml-2">
                <InfoIcon
                  :size="17"
                  :text="$t(`views.orders.orderModal.positionNumber.info.${typeOrderModal}`)"
                />
              </span>
            </div>
          </div>
          <v-chip
            v-if="
              ['sell', 'switch', 'spinOff', 'optionSell', 'withdrawal', 'brokerTransfer'].indexOf(
                typeOrderModal
              ) > -1 && positionBrokerPositionNumber > 0
            "
            small
            class="mt-2"
            @click="getAllPositionNumberAndAssign('positionNumber')"
          >
            <v-icon size="15" class="mr-1">
              {{
                typeOrderModal === 'spinOff'
                  ? 'mdi-basket-check-outline'
                  : 'mdi-basket-remove-outline'
              }}
            </v-icon>
            {{
              $t(`views.orders.orderModal.positionNumber.getAllPositionNumber.${typeOrderModal}`)
            }}
          </v-chip>
          <v-chip
            v-if="
              ['buy', 'optionBuy'].indexOf(typeOrderModal) > -1 && positionBrokerPositionNumber < 0
            "
            small
            class="mt-2"
            @click="getAllPositionNumberAndAssign('positionNumber')"
          >
            <v-icon size="15" class="mr-1">mdi-basket-plus-outline</v-icon>
            {{
              $t(`views.orders.orderModal.positionNumber.getAllPositionNumber.${typeOrderModal}`)
            }}
          </v-chip>
        </v-col>
        <v-col v-if="showPrice" cols="12" md="4">
          <CurrencyPriceOrTotal
            v-model="myOrder.price"
            :positionNumber="myOrder.positionNumber"
            :currency="position.currency"
            :labelPrice="
              typeOrDerivativeType === 'cash' && position.ticker
                ? $t('views.orders.orderModal.price.cash') +
                  ` ${position.ticker}/${position.currency}`
                : $t(`views.orders.orderModal.price.${typeOrDerivativeType}`)
            "
            :showCurrency="typeOrDerivativeType !== 'cash'"
            :disabled="loading"
          />
        </v-col>
        <v-col
          v-if="
            [
              'buy',
              'sell',
              'switch',
              'sharePremium',
              'scrip',
              'capitalIncrease',
              'optionBuy',
              'optionSell',
            ].indexOf(typeOrderModal) > -1
          "
          cols="12"
          md="4"
        >
          <CurrencyInput
            v-model="myOrder.comission"
            :currency="myOrder.comissionCurrency"
            :label="$t('views.orders.orderModal.comission')"
            :disabled="loading"
          />
          <InputCurrencySelector
            v-model="myOrder.comissionCurrency"
            :currencyOptions="currencyOptions"
            :infoText="$t(`views.orders.orderModal.comissionCurrencyInfo`)"
          />
        </v-col>

        <v-col
          v-if="
            position.ticker &&
            ['buy', 'sell'].indexOf(typeOrderModal) > -1 &&
            ['cash', 'crypto'].indexOf(type) > -1
          "
          cols="12"
          md="12"
        >
          <v-alert
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
            class="pa-2 alert-cash-cripto"
          >
            {{
              `${$t(`views.orders.orderModal.cashCryptoInfo.${typeOrderModal}.a`)} ${
                position.ticker
              } ${$t(`views.orders.orderModal.cashCryptoInfo.${typeOrderModal}.b`)} ${
                user.baseCurrency
              }?`
            }}
            {{ $t(`views.orders.orderModal.cashCryptoInfo.${typeOrderModal}.c-${type}`) }}
          </v-alert>
        </v-col>

        <template
          v-if="['spinOff', 'brokerTransfer'].indexOf(typeOrderModal) === -1 && showExchangeRate"
        >
          <v-col cols="12" md="12" class="my-0 py-0">
            <v-switch v-model="myOrder.customExchangeRate" :disabled="loading" hide-details>
              <template v-slot:label>
                <span class="mr-2">
                  {{ $t(`views.orders.orderModal.customExchangeRate.switch`) }}
                </span>
                <InfoIcon :text="$t(`views.orders.orderModal.customExchangeRate.info`)" />
              </template>
            </v-switch>
          </v-col>
          <v-col v-if="myOrder.customExchangeRate" cols="12" md="6" class="my-0 py-0 mt-2">
            <ExchangeRateInput
              v-model="myOrder.exchangeRate"
              :exchangeRatePair="exchangeRatePair"
              :disabled="loading"
              @rotateExchangeRatePair="$emit('rotateExchangeRatePair')"
            />
          </v-col>
        </template>

        <template
          v-if="
            ['buy', 'bonus', 'stakeReward', 'drip', 'sell', 'optionSell'].indexOf(typeOrderModal) >
            -1
          "
        >
          <v-col cols="12" md="12" class="my-0 py-0">
            <v-switch v-model="showOrderTaxes" :disabled="loading" hide-details>
              <template v-slot:label>
                <span class="mr-2">
                  {{ $t(`views.orders.orderModal.taxes.switch`) }}
                </span>
                <InfoIcon :text="$t(`views.orders.orderModal.taxes.info`)" />
              </template>
            </v-switch>
          </v-col>
          <v-col v-if="showOrderTaxes" cols="12" md="6" class="my-0 py-0 mt-2">
            <CurrencyInput
              v-model="myOrder.taxes"
              :currency="myOrder.taxesCurrency"
              :label="$t('views.orders.orderModal.taxes.label')"
              :disabled="loading"
            />
            <InputCurrencySelector
              v-model="myOrder.taxesCurrency"
              :currencyOptions="currencyOptions"
              :infoText="$t(`views.orders.orderModal.taxes.currencyInfo`)"
            />
          </v-col>
        </template>

        <template
          v-if="
            ['commission', 'interest', 'interestRetention', 'bonus'].indexOf(typeOrderModal) > -1
          "
        >
          <v-col cols="12" md="12" class="my-0 py-0">
            <v-switch v-model="myOrder.deductible" :disabled="loading" hide-details>
              <template v-slot:label>
                <span class="mr-2">
                  {{
                    $t(
                      `views.orders.orderModal.deductible.${
                        user.country === 'ES' ? user.country : 'default'
                      }.${typeOrderModal}.switch`
                    )
                  }}
                </span>
                <InfoIcon
                  :text="
                    $t(
                      `views.orders.orderModal.deductible.${
                        user.country === 'ES' ? user.country : 'default'
                      }.${typeOrderModal}.info`
                    )
                  "
                />
              </template>
            </v-switch>
          </v-col>
        </template>

        <template
          v-if="
            typeOrderModal === 'sell' ||
            (['interest', 'bonus'].indexOf(typeOrderModal) > -1 && typeOrDerivativeType === 'cash')
          "
        >
          <v-col cols="12" md="12" class="my-0 py-0">
            <v-switch v-model="showDestinationRetention" :disabled="loading" hide-details>
              <template v-slot:label>
                <span class="mr-2">
                  {{ $t(`views.orders.orderModal.destinationRetentionBaseCurrency.switch`) }}
                </span>
                <InfoIcon
                  :text="
                    typeOrderModal === 'sell'
                      ? $t(`views.orders.orderModal.destinationRetentionBaseCurrency.info`)
                      : $t(
                          `views.orders.orderModal.destinationRetentionBaseCurrency.interest-bonus-info`
                        )
                  "
                />
              </template>
            </v-switch>
          </v-col>
          <v-col v-if="showDestinationRetention" cols="12" md="6" class="my-0 py-0 mt-2">
            <CurrencyInput
              v-model="myOrder.destinationRetentionBaseCurrency"
              :currency="user.baseCurrency"
              :label="$t('views.orders.orderModal.destinationRetentionBaseCurrency.label')"
              :disabled="loading"
            />
          </v-col>
        </template>

        <template
          v-if="
            [
              'bonus',
              'drip',
              'stakeReward',
              'switch',
              'switchBuy',
              'commission',
              'paidInterest',
              'interest',
              'interestRetention',
              'deposit',
              'withdrawal',
            ].indexOf(typeOrderModal) === -1
          "
        >
          <!-- <template>
            <v-col cols="12" md="12" class="my-0 mt-2 py-0">
              <v-switch v-model="order.fxActive" :disabled="loading" hide-details>
                <template v-slot:label>
                  <span class="mr-2">
                    {{ $t(`views.common.fxActive.switch.${typeOrderModal}`) }}
                  </span>
                  <InfoIcon :text="$t(`views.common.fxActive.info`)" />
                </template>
              </v-switch>
            </v-col>
          </template> -->
          <template
            v-if="
              order.fxActive &&
              ['switch', 'bonus', 'stakeReward', 'drip', 'spinOff', 'brokerTransfer'].indexOf(
                typeOrderModal
              ) === -1 &&
              showExchangeRate
            "
          >
            <v-col cols="12" md="12" class="my-0 py-0">
              <v-switch v-model="myOrder.autoFx" :disabled="loading" hide-details>
                <template v-slot:label>
                  <span class="mr-2">
                    {{ $t(`views.common.autoFx.switch`) }}
                  </span>
                  <InfoIcon
                    :text="
                      $t(`views.common.autoFx.info1`) +
                      user.baseCurrency +
                      $t(`views.common.autoFx.info2`) +
                      user.baseCurrency +
                      $t(`views.common.autoFx.info3`)
                    "
                  />
                </template>
              </v-switch>
            </v-col>
          </template>
        </template>
      </template>
    </v-row>

    <template v-if="typeOrderModal === 'switch'">
      <OrderSwitchForm
        :myOrder="myOrder"
        :position="position"
        :loading="loading"
        :editing="editing"
      />
    </template>

    <template v-if="typeOrderModal === 'spinOff'">
      <OrderSpinOffForm
        :myOrder="myOrder"
        :position="position"
        :loading="loading"
        :editing="editing"
      />
    </template>

    <template v-if="typeOrderModal === 'split'">
      <OrderSplitForm
        :positionNumber.sync="myOrder.positionNumber"
        :price.sync="myOrder.price"
        :loading="loading"
      />
    </template>

    <template v-if="typeOrderModal === 'brokerTransfer'">
      <OrderBrokerTransferForm :myOrder="myOrder" :loading="loading" />
    </template>

    <v-row>
      <v-col cols="12" md="12" class="pb-0 pt-4 mt-1">
        <TagBox
          v-model="myOrder.tags"
          group="order"
          :disabled="loading"
          :label="$t('views.orders.orderModal.tags.label')"
          :hint="$t('views.orders.orderModal.tags.hint')"
        />
      </v-col>

      <v-col cols="12" md="12" class="mt-2 pt-0">
        <v-textarea
          v-model="myOrder.description"
          :label="$t(`views.orders.orderModal.description`)"
          :disabled="loading"
          background-color="transparent"
          auto-grow
          hide-details
          rows="1"
          maxlength="500"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find, get } from 'lodash'
import { OZT_TO_GR_RATE } from '@/lib/utils/math.js'
import DatePicker from '@/views/components/core/DatePicker'
import InfoIcon from '@/views/components/common/InfoIcon'
import CurrencyInput from '@/views/components/common/CurrencyInput'
import CurrencyPriceOrTotal from '@/views/components/common/CurrencyPriceOrTotal'
import InputCurrencySelector from '@/views/components/common/InputCurrencySelector'
import ExchangeRateInput from '@/views/components/common/ExchangeRateInput'
import BrokerSearch from '@/views/components/common/BrokerSearch'
import BrokerAlert from '@/views/components/common/BrokerAlert'
import TagBox from '@/views/components/common/TagBox'
import OrderSwitchForm from '@/views/components/common/orders/OrderSwitchForm'
import OrderSplitForm from '@/views/components/common/orders/OrderSplitForm'
import OrderBrokerTransferForm from '@/views/components/common/orders/OrderBrokerTransferForm'
import OrderSpinOffForm from '@/views/components/common/orders/OrderSpinOffForm'

export default {
  components: {
    DatePicker,
    InfoIcon,
    CurrencyInput,
    CurrencyPriceOrTotal,
    InputCurrencySelector,
    BrokerSearch,
    BrokerAlert,
    TagBox,
    ExchangeRateInput,
    OrderSwitchForm,
    OrderSplitForm,
    OrderBrokerTransferForm,
    OrderSpinOffForm,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
    position: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    typeOrDerivativeType: {
      type: String,
      default: null,
    },
    typeOrderModal: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    duplicating: {
      type: Boolean,
      default: false,
    },
    showExchangeRate: {
      type: Boolean,
      default: false,
    },
    exchangeRatePair: {
      type: String,
      default: null,
    },
    brokerMultiCurrency: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myOrder: null,
    brokerSearchBrokers: [],
    brokerSearchLoading: false,
    currencyOptions: [],
    showOrderTaxes: false,
    showDestinationRetention: false,
  }),
  computed: {
    ...mapState(['user']),
    isSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown
    },
    multiCurrencyBroker() {
      return this.myOrder && this.myOrder.broker && this.myOrder.broker.multiCurrency
    },
    positionBrokerPositionNumber() {
      if (!this.myOrder.broker || !this.position.brokers || !this.position.brokers.length)
        return undefined

      const positionBroker = find(
        this.position.brokers,
        (broker) => broker.broker._id === this.myOrder.broker._id
      )
      if (!positionBroker) return undefined
      return positionBroker.positionNumber
    },
    showPrice() {
      return (
        ['spinOff', 'brokerTransfer'].indexOf(this.typeOrderModal) === -1 &&
        (this.position.type !== 'cash' || this.position.ticker !== this.user.baseCurrency)
      )
    },
  },
  watch: {
    myOrder: {
      handler() {
        if (!this.myOrder) return
        if (JSON.stringify(this.myOrder) === JSON.stringify(this.order)) return
        this.$emit('update:order', this.myOrder)
      },
      deep: true,
    },
    order: {
      handler() {
        this.myOrder = JSON.parse(JSON.stringify(this.order))
      },
      deep: true,
      immediate: true,
    },
    position: {
      handler() {
        if (!this.position) return

        // SET COMISSION CURRENCY OPTIONS
        if (this.position.currency !== this.user.baseCurrency) {
          this.currencyOptions = [this.user.baseCurrency, this.position.currency]
        } else {
          if (
            ['buy', 'sell', 'switch'].indexOf(this.typeOrderModal) > -1 &&
            ['cash', 'crypto'].indexOf(this.typeOrDerivativeType) > -1
          ) {
            this.currencyOptions = [this.user.baseCurrency, this.position.ticker]
          } else {
            this.currencyOptions = []
          }
        }

        if (this.editing || this.duplicating) return

        // SELECT ITS UNIQUE BROKER BY DEFAULT
        if (this.position.brokers) {
          if (this.position.brokers.length === 1)
            this.$set(this.myOrder, 'broker', this.position.brokers[0].broker)
          else {
            const activeBrokers = this.position.brokers.filter((elem) => elem.positionNumber > 0)
            if (activeBrokers.length === 1)
              this.$set(this.myOrder, 'broker', activeBrokers[0].broker)
          }
        }

        this.selectDefaultBrokerValues()
      },
      deep: true,
      immediate: true,
    },
    'myOrder.broker'(newBroker, oldBroker) {
      // evito watch falsos, saltan sin que cambie al cambiar el exchangeRate...
      if (JSON.stringify(newBroker) !== JSON.stringify(oldBroker)) {
        if (this.myOrder.broker) this.selectDefaultBrokerValues()
      }
    },
    'myOrder.taxes': {
      handler() {
        if (this.myOrder.taxes) {
          this.showOrderTaxes = true
        }
      },
      immediate: true,
    },
    showOrderTaxes() {
      if (!this.showOrderTaxes) this.myOrder.taxes = 0
    },
    'myOrder.destinationRetentionBaseCurrency': {
      handler() {
        if (this.myOrder.destinationRetentionBaseCurrency) {
          this.showDestinationRetention = true
        }
      },
      immediate: true,
    },
    'myOrder.metadata': {
      handler() {
        if (this.typeOrderModal === 'brokerTransfer' && !this.myOrder.newBroker) {
          const newBroker = get(this.myOrder, 'metadata.newBrokerId', undefined)
          if (newBroker) this.$set(this.myOrder, 'newBroker', newBroker)
        }
      },
      immediate: true,
    },
    showDestinationRetention() {
      if (!this.showDestinationRetention) this.myOrder.destinationRetentionBaseCurrency = 0
    },
  },
  methods: {
    changeCommodityUnit(unit) {
      if (this.myOrder.commodityUnit === unit) return

      if (unit === 'oz') {
        if (this.myOrder.positionNumber) {
          this.$set(this.myOrder, 'positionNumber', this.myOrder.positionNumber / OZT_TO_GR_RATE)
        }
        if (this.myOrder.price) {
          this.$set(this.myOrder, 'price', this.myOrder.price * OZT_TO_GR_RATE)
        }
      } else if (unit === 'gr') {
        if (this.myOrder.positionNumber) {
          this.$set(this.myOrder, 'positionNumber', this.myOrder.positionNumber * OZT_TO_GR_RATE)
        }
        if (this.myOrder.price) {
          this.$set(this.myOrder, 'price', this.myOrder.price / OZT_TO_GR_RATE)
        }
      }
    },
    getAllPositionNumberAndAssign(assignTo) {
      if (this.positionBrokerPositionNumber) {
        this.$set(this.myOrder, assignTo, Math.abs(this.positionBrokerPositionNumber))
      } else {
        this.$set(this.myOrder, assignTo, null)
      }
    },
    selectDefaultBrokerValues() {
      if (this.editing || this.duplicating) return

      if (this.multiCurrencyBroker) {
        this.$set(this.myOrder, 'comissionCurrency', this.position.currency)
        this.$set(this.myOrder, 'taxesCurrency', this.position.currency)
        this.$set(this.myOrder, 'customExchangeRate', false)
        this.$set(this.myOrder, 'autoFx', false)
      } else {
        this.$set(this.myOrder, 'comissionCurrency', this.user.baseCurrency)
        this.$set(this.myOrder, 'taxesCurrency', this.user.baseCurrency)
        this.$set(this.myOrder, 'customExchangeRate', !!this.showExchangeRate)
        this.$set(this.myOrder, 'autoFx', !!this.showExchangeRate)
      }

      if (this.typeOrderModal === 'switch') {
        this.myOrder.switch.switchBuyBroker = JSON.parse(JSON.stringify(this.myOrder.broker))
      }
    },
    getPositionNumberCurrency() {
      if (this.typeOrDerivativeType === 'commodity') {
        if (['GC', 'SI', 'PL', 'PA'].indexOf(this.position.ticker) > -1)
          return this.myOrder.commodityUnit
      }
      return this.position.ticker
    },
    deleteTag(tag) {
      this.$set(
        this.myOrder,
        'tags',
        this.myOrder.tags.filter((item) => {
          return item !== tag
        })
      )
    },
  },
}
</script>

<style lang="scss">
#order-form {
  .items-flex {
    display: flex;
    &.align-end {
      align-items: flex-end;
    }
  }
  .alert-cash-cripto {
    font-size: 13px;
  }
  .commodity-unit-buttons {
    .v-btn__content {
      text-transform: none;
    }
  }
}
</style>
